import { render, staticRenderFns } from "./FormButton.vue?vue&type=template&id=561515cb&scoped=true&"
import script from "./FormButton.vue?vue&type=script&lang=js&"
export * from "./FormButton.vue?vue&type=script&lang=js&"
import style0 from "./FormButton.vue?vue&type=style&index=0&id=561515cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561515cb",
  null
  
)

export default component.exports